<template>
    <div v-html="bldTpl_Stmp_Cmpl(flightdirection, pax)">
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flightdirection', 'pax'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                smlegend: {
                    en: 'Seating plan Legend',
                    de: 'Sitzplan Legende',
                },
                smseattypes: {
                    en: 'Seat Types:',
                    de: 'Sitztypen:',
                },
                smreserved: {
                    en: 'Reserved',
                    de: 'Reserviert',
                },
                smseattypesexplanations: {
                    en: 'Make your choice.',
                    de: 'Treffen Sie Ihre Wahl.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getBookingSeatReservationLockingCodeResults',
                'getBookingSeatPlanOutwardResults',
                'getBookingSeatPlanReturnResults',
                'getBookingCartIsSeatAlreadyReserved',
                'getBookingSeatFreeColor',
                'getBookingUsersSearchData'
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Utilities: Build Seatmap(s)
            *******************************************************************/
            /*******************************************************************
            * bldTpl_Stmp_Cmpl()
            *
            * Desc: Build Seatmap Complete.
            * Note:
            *
            * @param {String} flightdirection
            * @param {Object} pax
            * @return {String}
            */
            bldTpl_Stmp_Cmpl: function (flightdirection, pax) {

                var me = this,
                    s  = '';


                me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTpl_Stmp_Cmpl');
                s += me.bldTplSs_Stmp_Legend(flightdirection);
                s += me.bldTplSs_Stmp(flightdirection, pax);


                return s;

            }, // eof bldTpl_Stmp_Cmpl()

            /*******************************************************************
            * bldTplSs_Stmp()
            *
            * Desc: Build Subset of Seatmap.
            * Note: Cockpit Pic (Width?) ->
            * Note: (seats_per_row + 2) x 14 (pix - Seatwidth)
            * Note: + (seats_per_row + 3) x 2 (pixel Spacer between Seats)
            * Note: + Rahmen 6 px
            * Note:
            *
            * @param {String}
            * @param {String}
            * @return {String}
            */
            bldTplSs_Stmp: function (flightdirection, pax) {

                var me = this,
                    s  = '',
                    cellStore = '',
                    cellRows = [],
                    seats_per_row = 0,
                    cockpitType = '',
                    seatDetail = '',
                    cell_callback_class = null;


                me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTplSs_Stmp');
                // >>> The right 'Source' to use -------------------------------
                if (flightdirection === 'outward') {
                    cellStore = this.getBookingSeatPlanOutwardResults;
                    cell_callback_class = 'confirmation-callback-cells-outward';
                }
                if (flightdirection === 'return') {
                    cellStore = this.getBookingSeatPlanReturnResults;
                    cell_callback_class = 'confirmation-callback-cells-return';
                }
                // <<< The right 'Source' to use -------------------------------


                // >>> Build Cockpit -------------------------------------------
                seats_per_row = parseInt(cellStore.getSeatPlanResponse.cellRows[2].seatCells.length, 10);
                cockpitType = ((seats_per_row * 25) + 6) + ((seats_per_row * 2) + 2);
                s += me.bldTplSs_Stmp_Cockpit(cockpitType);
                // <<<s Build Cockpit ------------------------------------------


                // >>> 'Row per Row & Cell per Cell' ---------------------------
                s += '<div align="center" style="padding-top: 0px;">';
                s += '   <table class="seatmap" border="0">';
                s += '   <tbody>';



                // >>> ---------------------------------------------------------
                // >>> Row per Row, from Left to Right -------------------------
                cellRows = cellStore.getSeatPlanResponse.cellRows;
                for (var i = 0; i < cellRows.length; i++) {
                    s += '<tr>';

                    // >>> -----------------------------------------------------
                    // >>> Left Row Desc-Row ----------------------------------- /* Left to Right: 1 */
                    s += '<td bgcolor="#FFFFFF" class="seatmap_header">';
                    if (cellRows[i].hasSeats) {
                        for (var x = 1; cellRows[i].seatCells.length; x++) { // Not cool! Try to find out ROW Desc
                            if (cellRows[i].seatCells[x].seatName !== undefined) {
                                s += cellRows[i].seatCells[x].seatName.length === 2 ? cellRows[i].seatCells[x].seatName.substring(0, 1) : cellRows[i].seatCells[x].seatName.substring(0, 2);
                                break;
                            }
                        }
                    } else {
                        s += ' &nbsp;';
                    }
                    s += '</td>';
                    // <<< Left Row Desc-Row -----------------------------------
                    // <<< -----------------------------------------------------


                    // >>> -----------------------------------------------------
                    // >>> Left Space-Row --------------------------------------  /* Left to Right: 2 */
                    s += '<td bgcolor="#FFFFFF" width="3" style="width: 3px;">';
                    s += '  &nbsp;';
                    s += '</td>';
                    // <<< Left Space-Row --------------------------------------
                    // <<< -----------------------------------------------------


                    // >>> -----------------------------------------------------
                    // >>> Left Wing/Row --------------------------------------- /* Left to Right: 3 */
                    s += '<td style="background-color: #FFFFFF;">';
                    if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row || cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                        if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row) {
                            s += '<img src="/res/images/services/seats/wing_left-start.png">';
                        }
                        if (cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                            s += '  <img src="/res/images/services/seats/wing_left-start.png">';
                        }
                    } else {
                        s += '&nbsp;';
                    }
                    s += '</td>';
                    // <<< Left Wing/Row ---------------------------------------
                    // <<< -----------------------------------------------------


                    // >>> ----------------------------------------------------- /* Left to Right: 4 */
                    // >>> Left FrameBorder ------------------------------------
                    if (cellRows[i].row === -1) {
                        s+= '<td rowspan="' + parseInt(cellRows.length, 10) + '" bgcolor="#cccccc" width="3" height="3" style="width:3px;min-width:3px;height:3px;min-height:3px;">';
                        s+= '   <img src="/res/images/services/seats/op.gif" width="3" height="3" style="height: 3px; width: 3px;">';
                        s+= '</td>';
                    }
                    // <<< Left FrameBorder ------------------------------------
                    // <<< -----------------------------------------------------





                    // >>> -----------------------------------------------------
                    // >>> Cell per Cell, from Left to Right -------------------
                    for (var x = 0; x < cellRows[i].seatCells.length; x++) {

                        seatDetail = me.whatSeatDetails(cellRows[i].seatCells[x], flightdirection, pax);

                        // s += '<td bgcolor="' + seatDetail.cellColor + '" id="' + seatDetail.cellId + '" class="' + seatDetail.tdClass + '">' + seatDetail.tdContent +'</td>'; // {c1} IS OK
                        if (seatDetail.tdClass === 'realseat' || seatDetail.tdClass === 'seatblocked') {
                        s += '<td bgcolor="' + seatDetail.cellColor + '" id="' + seatDetail.cellId + '" class="' + seatDetail.tdClass + '"><a href="#" class="btn ' + cell_callback_class + '" data-target="' + seatDetail.cellId + '" style="padding: 0px 0px;">' + seatDetail.tdContent + '</a></td>'; // {c1}
                        } else {
                        s += '<td bgcolor="' + seatDetail.cellColor + '" id="' + seatDetail.cellId + '" class="' + seatDetail.tdClass + '">' + seatDetail.tdContent + '</td>'; // {c1}
                        }

                    }
                    // <<< Cell per Cell, from Left to Right -------------------
                    // <<< -----------------------------------------------------





                    // >>> -----------------------------------------------------
                    // >>> Right FrameBorder -----------------------------------
                    if (cellRows[i].row === -1) {
                        s+= '<td rowspan="' + parseInt(cellRows.length, 10) + '" bgcolor="#cccccc" width="3" height="3" style="width:3px;min-width:3px;height:3px;min-height:3px;">';
                        s+= '   <img src="/res/images/services/seats/op.gif" width="3" height="3" style="height: 3px; width: 3px;">';
                        s+= '</td>';
                    }
                    // <<< Right FrameBorder -----------------------------------
                    // <<< -----------------------------------------------------


                    // >>> -----------------------------------------------------
                    // >>> Right Wing/Row --------------------------------------
                    s += '<td style="background-color: #FFFFFF;">';
                    if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row || cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                        if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row) {
                            s += '<img src="/res/images/services/seats/wing_right-start.png">';
                        }
                        if (cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                            s += '<img src="/res/images/services/seats/wing_right-start.png">';
                        }
                    } else {
                        s += '&nbsp;';
                    }
                    s += '</td>';
                    // <<< Right Wing/Row --------------------------------------
                    // <<< -----------------------------------------------------

                    s += '  </tr>';
                }
                // <<< Row per Row, from Left to Right -------------------------
                // <<< ---------------------------------------------------------



                // >>> FrameBorder Bottom --------------------------------------
                s += '  <tr>';
                s += '      <td bgcolor="#FFFFFF" width="3" style="line-height: 3px; height: 3px;">'; // >>> Row Desc/Row, one Cell
                s += '           &nbsp;';
                s += '       </td>';

                s += '      <td bgcolor="#FFFFFF" width="3" style="line-height: 3px; height: 3px;">'; // >>> Space/Row, one Cell
                s += '           &nbsp;';
                s += '       </td>';

                s += '       <td bgcolor="#FFFFFF" height="3" style="line-height: 3px; height: 3px;">'; // >>> Left Wing/Row, one Cell
                s += '           &nbsp;';
                s += '       </td>';


                s += '       <td colspan="' + parseInt(cellStore.getSeatPlanResponse.cellRows[2].seatCells.length + 2, 10) + '" bgcolor="#CCCCCC" height="3" style="line-height: 3px; height: 3px;">'; /* +2 bec. Frame */
                s += '           <img src="/res/images/services/seats/op.gif" style="height: 3px; width: 3px;">';
                s += '       </td>';


                s += '       <td bgcolor="#FFFFFF" height="3" style="line-height: 3px; height: 3px;">'; // >>> Right Wing/Row, one Cell
                s += '           &nbsp;';
                s += '       </td>';
                s += '  </tr>';
                // >>> FrameBorder Bottom --------------------------------------


                s += '  </tbody>';
                s += '  </table>';
                s += '</div>';
                // <<< 'Row per Row & Cell per Cell' ---------------------------


                return s;

            }, // eof bldTplSs_Stmp()



            /**************************************************************************
            * bldTplSs_Stmp_Legend()
            *
            * Desc: Builds and Returns Seatmaps Legend.
            * Note:
            *
            * @param {String} flightdirection ('outward', 'return')
            * @return {String}
            */
            bldTplSs_Stmp_Legend: function (flightdirection) {

                var me = this,
                    s = '',
                    storeSeatplan = '',
                    seatTypes = [];


                me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTplSs_Stmp_Legend');
                // >>> The right 'Source' to use -------------------------------
                if (flightdirection === 'outward') {
                    storeSeatplan = this.getBookingSeatPlanOutwardResults;
                }
                if (flightdirection === 'return') {
                    storeSeatplan = this.getBookingSeatPlanReturnResults;
                }
                // <<< The right 'Source' to use -------------------------------


                s += '<div class="travel-story-container box" style="padding: 0px; margin-bottom: 0px;">';
                s += '  <div class="travel-story-content">';
                s += '      <div class="description" style="padding: 0px;">';


                s += '          <div class="panel style1" style="margin-bottom: 0px; border: 0px; box-shadow: none; -webkit-box-shadow: none;">';
                s += '              <h4 class="skin-color panel-title"><span class="index"><i class="soap-icon-bottom"></i></span>';
                s += '                  <a href="#tgg1_' + flightdirection + '" data-toggle="collapse">' + me.smlegend[me.getCurrentLocale] + ':</a>';
                s += '              </h4>';
                s += '              <div class="panel-collapse collapse in" id="tgg1_' + flightdirection + '">';
                s += '                  <div class="panel-content">';


                // s += '<br /><p>' + me.smseattypesexplanations[me.getCurrentLocale] + '</p>';
                s += '<br /><div class="my-trip">';
                s += '  <h5>' + me.smseattypes[me.getCurrentLocale] + '</h5>';
                s += '  <ul>';
                // >>> Build Legend --------------------------------------------
                seatTypes = storeSeatplan.getSeatPlanResponse.seatTypes;
                for (var i = 0; i < seatTypes.length; i++) {
                    s += '<li>';
                    s += '  <center><a class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #' + seatTypes[i].colorFree + ';">';
                    s += '      <br />' + seatTypes[i].description + ' ' + seatTypes[i].price + '&euro;'
                    s += '  </a></center>';
                    s += '</li>';
                }
                s += '<li>';
                s += '  <center><a class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #' + seatTypes[0].colorReserved + ';"><br />';
                s +=  me.smreserved[me.getCurrentLocale];
                s += '  </a></center>';
                s += '</li>';
                // <<< Build Legend --------------------------------------------
                s += '  </ul>';
                s += '</div>';


                s += '                  </div>'; // end: panel-content
                s += '              </div>'; // end: panel-collapse collapse
                s += '          </div>'; // end: panel


                s += '        </div>';  // end: class="description
                s += '    </div>'; // end: class="travel-story-content
                s += '</div>'; // end: class="travel-story-container


                return s;

            }, // eof bldTplSs_Stmp_Legend()

            /*******************************************************************
            * bldTplSs_Stmp_Cockpit()
            *
            * Desc: Builds 'Cockpit' Pic at the Top.
            * Note: Different sizes per different Seats per Row.
            *
            * @param {String} cp (Cockpit: )
            * @return {String}
            */
            bldTplSs_Stmp_Cockpit: function (cp) {

                var me = this,
                    s = '',
                    padding = 0;


                me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTplSs_Stmp_Cockpit');
                // 6    SeatsPerRow = 170 (A41 - TXl-SXB)
                // 8    SeatsPerRow = 224 (VIM - VAR-MUC)
                // 9    SeatsPerRow = 136 (A41 - TXl-BSL)
                // 11   SeatsPerRow = 305 (A41 - TXL-CHICAGO)

                if (cp === 170) { padding = 54; }
                if (cp === 224) { padding = 54; }
                if (cp === 251) { padding = 54; }
                if (cp === 305) { padding = 54; }
                if (cp === 359) { padding = 54; }

                if (cp === 170 || cp === 224 || cp === 251 || cp === 305 || cp === 359) {
                    s += '<div align="center" style="padding-top: 10px;">';
                    s += '  <table border="0">';
                    s += '  <tr>';
                    s += '      <td align="center">';
                    s += '          <img src="/res/images/services/seats/cockpit_' + cp + '.png" align="top" style="padding-left:' + padding + 'px;">';
                    s += '      </td>';
                    s += '  </tr>';
                    s += '  </table>';
                    s += '</div>';
                }


                return s;

            }, // eof bldTplSs_Stmp_Cockpit()




            /*******************************************************************
            * whatSeatDetails()
            *
            * Desc:
            * Note: Known Seat/Cell - Types, 'SEAT', 'BLANK', 'LAVATORY'.
            *
            * @param {object} values (Exact Cell Infos)
            * @param {object} type (FlightDirection)
            * @param {object} pax (Pax)
            *
            * @return {object} type (Flight Direction)
            */
            whatSeatDetails: function (values, type, pax) {

                var me = this,
                    tmp_available = '',
                    tmp_availableForChild = '',
                    tmp_availableWithInfant = '',
                    tmp_availableWithoutInfant = '',
                    x = [],
                    z = [],
                    cellStore = '',
                    seatDetail = {};


                // me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> whatSeatDetails');
                // >>> The right Source to use ---------------------------------
                if (type === 'outward') {
                    cellStore = this.getBookingSeatPlanOutwardResults;
                }
                if (type === 'return') {
                    cellStore = this.getBookingSeatPlanReturnResults;
                }
                // <<< The right Source to use ---------------------------------


                // >>> Decide --------------------------------------------------
                switch (values.type) {
                    case "BLANK":
                        seatDetail.cellId = 'no';
                        seatDetail.cellColor = 'FFFFFF';
                        seatDetail.tdContent = '<img src="/res/images/services/seats/op.gif">';
                        seatDetail.tdClass = '';
                        break;
                    case "LAVATORY":
                        seatDetail.cellId = 'no';
                        seatDetail.cellColor = 'FFFFFF';
                        seatDetail.tdContent = '<img src="/res/images/services/seats/wc.png">';
                        seatDetail.tdClass = '';
                        break;
                    case "EXIT":
                        seatDetail.cellId = 'no';
                        seatDetail.cellColor = 'FFFFFF';
                        if(values.orientation === 'LEFT_FLANK') {
                            seatDetail.tdContent = '<img src="/res/images/services/seats/exit-left.png">';
                        } else {
                            seatDetail.tdContent = '<img src="/res/images/services/seats/exit-right.png">';
                        }
                        seatDetail.tdClass = '';
                        break;
                    case "EMERGENCY_EXIT":
                        seatDetail.cellId  = 'no';
                        seatDetail.cellColor = 'FFFFFF';
                        if(values.orientation === 'LEFT_FLANK') {
                            seatDetail.tdContent = '<img src="/res/images/services/seats/emexit-left.png">';
                        } else {
                            seatDetail.tdContent = '<img src="/res/images/services/seats/emexit-right.png">';
                        }
                        seatDetail.tdClass = '';
                        break;
                    case "HEADER":
                        seatDetail.cellId = 'no';
                        seatDetail.cellColor ='FFFFFF';
                        seatDetail.tdContent = values.description;
                        seatDetail.tdClass = 'seatmap_header';
                        break;
                    case "S": // CellType::SEAT
                        x = me.stR_Str_Seatplan_For_SeatColor(values.seatInfo, values.seatName, type, pax.pax.kop, pax.pax.id_pax);

                        tmp_available = values.seatInfo.available === true ? 1 : 0; // trick only: true === 1
                        tmp_availableForChild = values.seatInfo.availableForChild === true ? 1 : 0;
                        tmp_availableWithInfant = values.seatInfo.availableWithInfant === true ? 1 : 0;
                        tmp_availableWithoutInfant = values.seatInfo.availableWithoutInfant === true ? 1 : 0;

                        if (x[0] === true) { // Reserved in Cart already
                            seatDetail.cellId = String(values.seatName + '_' + values.seatInfo.code + '_' + tmp_available + tmp_availableForChild + tmp_availableWithInfant + tmp_availableWithoutInfant + '_' + type + '_' + pax.pax.id_pax + '_' + pax.pax.kop);
                            seatDetail.cellColor = x[2]; //A41M.app.gp_SEATCLR_BLANK;
                            seatDetail.tdContent = x[1];
                            seatDetail.tdClass = '';
                        }

                        if (x[0] !== true) { // NOT Reserved in Cart already
                            seatDetail.cellId = String(values.seatName + '_' + values.seatInfo.code + '_' + tmp_available + tmp_availableForChild + tmp_availableWithInfant + tmp_availableWithoutInfant + '_' + type + '_' + pax.pax.id_pax + '_' + pax.pax.kop);
                            seatDetail.cellColor = x[1];

                            if(x[1] === 'ED1C24') { // color reserved -> No Seat Png!
                                seatDetail.tdClass = 'realseat taken';
                            } else {
                                seatDetail.tdClass = 'realseat';
                            }

                            if(x[2] === 'B') { // Blocked
                                //seatDetail.tdContent  = '<img src="/res/img/seats/blocked.png" style="width:14px; height:14px;">';
                                seatDetail.tdClass = 'seatblocked';
                                seatDetail.tdContent = '&nbsp;&nbsp;&nbsp;&nbsp;';
                            } else {
                                seatDetail.tdContent = '&nbsp;&nbsp;&nbsp;&nbsp;';
                            }
                        }
                        break;
                    default:
                        break;
                }


                return seatDetail;

            }, // eof whatSeatDetails()





            /*******************************************************************
            * Store Actions: Seats
            *******************************************************************/
            /*******************************************************************
            * Render 'SeatplanOut' & 'SeatplanRet'.
            *
            * Desc: Returns Seats Color (and Icon).
            * Note:
            *
            * @param {String} seatInfo ('seatInfo', to Identify Color&Avaibil.)
            * @param {String} seatName ('seatName', to recheck in Cart)
            * @param {String} type ('outward', 'return')
            * @param {String} kop (Kind of Persona)
            * @param {String} id_pax ()
            *
            * @return {String} seatColor
            */
            stR_Str_Seatplan_For_SeatColor: function(seatInfo, seatName, type, kop, id_pax) {

                var me = this,
                    storeSeatplan = '',
                    reservedAlreadyBy = '',
                    colorFree = '',
                    paxInfo = '',
                    seatColor = [],
                    seatCode = seatInfo.code, // s5->code
                    seatAvailable = seatInfo.available, // s1->available
                    seatAvailableForChild = seatInfo.availableForChild, // s2->availableForChild
                    seatAvailableWithInfant = seatInfo.availableWithInfant, // s3->availableWithInfant
                    seatAvailableWithoutInfant = seatInfo.availableWithoutInfant, // s4->availableWithoutInfant
                    seatBlocked = seatInfo.block, // New: 21012015
                    seatTypes = [];


                // me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> stR_Str_Seatplan_For_SeatColor');
                // >>> The right Source to use ---------------------------------
                if (type === 'outward') {
                    storeSeatplan = this.getBookingSeatPlanOutwardResults;
                }
                if (type === 'return') {
                    storeSeatplan = this.getBookingSeatPlanReturnResults;
                }
                // <<< The right Source to use ---------------------------------



                // >>> Already reserved? ---------------------------------------
                reservedAlreadyBy = this.getBookingCartIsSeatAlreadyReserved({seatName: seatName, type: type }); // gets pax
                // <<< Already reserved? ---------------------------------------



                // >>> Seat is: RESERVED ALREADY -------------------------------  /* means: already taken (in cart) */
                if (reservedAlreadyBy !== '') {

                    colorFree = this.getBookingSeatFreeColor({seatCode: seatCode, type: type });

                    // >>> Check for right 'reserved Icon' ---------------------
                    if (reservedAlreadyBy.type === 'CHD') {
                        if (reservedAlreadyBy.paxCredentials.gender === 'F') {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_girl.png">', colorFree);
                        } else {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_boy.png">', colorFree);
                        }
                    }

                    if (reservedAlreadyBy.type !== 'CHD') {
                        if (reservedAlreadyBy.paxCredentials.gender === 'F') {
                            if (this.travelsWithInfantNumber(id_pax) !== '') {
                                seatColor.push(true, '<img src="/res/images/services/seats/ic_woman_baby.png">', colorFree);
                            } else {
                                seatColor.push(true, '<img src="/res/images/services/seats/ic_woman.png">', colorFree);
                            }
                        }

                        if (reservedAlreadyBy.paxCredentials.gender === 'M') {
                            if (this.travelsWithInfantNumber(id_pax) !== '') {
                                seatColor.push(true, '<img src="/res/images/services/seats/ic_man_baby.png">', colorFree);
                            } else {
                                seatColor.push(true, '<img src="/res/images/services/seats/ic_man.png">', colorFree);
                            }
                        }

                        if (reservedAlreadyBy.paxCredentials.gender === undefined) {
                            if (this.travelsWithInfantNumber(reservedAlreadyBy.id_pax) !== '') {
                                seatColor.push(true, '<img src="/res/images/services/seats/ic_man_baby.png">', colorFree);
                            } else {
                                seatColor.push(true, '<img src="/res/images/services/seats/ic_man.png">', colorFree);
                            }
                        }
                    }
                    // <<< Check for right 'reserved Icon' ---------------------

                }
                // <<< Seat is: RESERVED ALREADY -------------------------------



                // >>> Seat is: NOT RESERVED ALREADY ---------------------------  /* means: not yet occupied (in cart) */
                if (reservedAlreadyBy === '') {

                    // >>> Seat is NOT yet reserved .. Find Color .. -----------
                    seatTypes = storeSeatplan.getSeatPlanResponse.seatTypes;
                    for (var i = 0; i < seatTypes.length; i++) {

                        if (seatTypes[i].code === seatCode) { // Right SeatType?
                            if (seatAvailable === true) {
                                switch (kop) { // A41M.app.gp_KOP
                                    case "AdultWithoutInfant":
                                        if (seatAvailableWithoutInfant === true) {
                                            seatColor.push(false, seatTypes[i].colorFree);
                                        } else {
                                            seatColor.push(false, seatTypes[i].colorReserved);
                                        }
                                        break;
                                    case "AdultWithInfant":
                                        if (seatAvailableWithInfant === true) {
                                            seatColor.push(false, seatTypes[i].colorFree);
                                        } else {
                                            seatColor.push(false, seatTypes[i].colorReserved);
                                        }
                                        break;
                                    case "Child":
                                        if (seatAvailableForChild === true) {
                                            seatColor.push(false, seatTypes[i].colorFree);
                                        } else {
                                            seatColor.push(false, seatTypes[i].colorReserved);
                                        }
                                        break;
                                    case "Nobody": // Only to See some Change
                                        seatColor.push(false, seatTypes[i].colorReserved);
                                        break;
                                    default:
                                        break;
                                }

                                // >>> Hack for : #2470 ------------------------
                                if (seatBlocked) {
                                    seatColor[2] = 'B'; // Set a 'B'
                                }
                                // <<< Hack for : #2470 ------------------------
                            }

                            if (seatAvailable === false) {
                                seatColor.push(false, seatTypes[i].colorReserved);
                            }
                        }

                    }
                    // <<< Seat is NOT yet reserved .. Find Color .. -----------

                }
                // <<< Seat is: NOT RESERVED ALREADY ---------------------------


                return seatColor;

            }, // eof stR_Str_Seatplan_For_SeatColor()





            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * travelsWithInfantNumber()
            *
            * Desc:
            * Note:
            *
            * @param {Int} id_pax
            * @return {Int} travelsWithInfantNumber
            */
            travelsWithInfantNumber: function(id_pax) {

                let me = this,
                    travelsWithInfantNumber = '',
                    countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                    countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                    countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                    countADTCHD = countADT + countCHD,
                    countADTCHDINF = countADTCHD + countINF;


                me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> travelsWithInfantNumber');
                // >>> ---------------------------------------------------------
                if (countINF === 0) {
                    travelsWithInfantNumber = '';
                }

                // >>> ---------------------------------------------------------
                if (countINF !== 0) {
                    // >>> Step 1: Catch every Pax Data (INF) ------------------
                    for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {
                        // >>> Arrange adults to a baby ------------------------
                        if (i === parseFloat(id_pax) + parseFloat(countADTCHD)) {
                            travelsWithInfantNumber = i;
                        }
                    }
                }


                return travelsWithInfantNumber;

            }, // eof travelsWithInfant()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/booking/passengers/services/SeatDetails.vue